<template>
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
  >
    <path d="M1.28401 8.29541C0.896393 8.68882 0.901082 9.32196 1.29449 9.70959C1.68789 10.0972 2.32104 10.0925 2.70866 9.69911L8 4.32882V17.9999C8 18.5522 8.44772 18.9999 9 18.9999C9.55229 18.9999 10 18.5522 10 17.9999V4.3353L15.2849 9.69911C15.6726 10.0925 16.3057 10.0972 16.6991 9.70959C17.0925 9.32196 17.0972 8.68882 16.7096 8.29541L9.88721 1.37122C9.3976 0.874307 8.59601 0.874306 8.1064 1.37122L1.28401 8.29541Z" />
  </svg>
</template>
